<template>
  <v-card class="d-flex flex-column pa-0 pt-0" light height="420px">
    <v-card-text class="pa-0">
      <v-list class="px-9">
        <v-row justify="center">
          <v-col class="px-1">
            <p class="px-0 my-0">
              {{
                $t(
                  "This list contains the most recent exports from this camera."
                )
              }}
            </p>
            <p class="px-0 my-0">
              {{
                $t(
                  "The downloads will expire within 30 minutes. Generating a video takes between 2 and 10 minutes."
                )
              }}
            </p>
          </v-col>
        </v-row>
      </v-list>
      <v-data-table
        class="table"
        hide-default-footer
        disable-sort
        fixed-header
        height="250px"
        :headers="headers"
        :items="jobs"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-text': '',
          'items-per-page-options': []
        }"
        calculate-widths
        dense
      >
        <template v-slot:body="{ items, headers }">
          <tbody>
            <td
              class="table-cell expanded-area no-exports text-center"
              :colspan="headers.length"
              v-if="jobs.length < 1"
            >
              {{ $t("No recent exports found") }}
            </td>
            <tr class="table-row" v-for="item in items" :key="item.id">
              <td class="table-cell status">{{ $t(item.status) }}</td>
              <td class="table-cell time">{{ $t(item.type) }}</td>
              <td class="table-cell time">{{ item.time }}</td>
              <td class="table-cell size">{{ item.size }}</td>
              <td class="table-cell btn">
                <v-layout justify-center>
                  <a
                    class="text-decoration-none"
                    :href="item.url"
                    v-if="item.status == 'Done'"
                    target="_blank"
                  >
                    <v-icon size="20" color="primary">
                      fa-cloud-download-alt
                    </v-icon>
                  </a>
                  <v-progress-circular
                    v-else-if="item.status == 'In progress'"
                    indeterminate
                    color="primary"
                    size="20"
                    width="3"
                  ></v-progress-circular>
                  <v-tooltip
                    max-width="300px"
                    color="error"
                    v-else-if="item.status == 'Failed'"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="error">
                        fa-exclamation-triangle
                      </v-icon>
                    </template>
                    <span>{{
                      $t(item.message ? item.message : "Unkown error occured")
                    }}</span>
                  </v-tooltip>
                </v-layout>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mr-3 mb-3" depressed @click="closeOverlay">{{
        $t("Close")
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {
  reactive,
  toRefs,
  computed,
  watch,
  onBeforeUnmount,
  onMounted
} from "../../plugins/compositionApi";
import restapi from "../../service/CMApi";
import { saveFile } from "../../service/main";
import { store } from "@/store/index";
import { t } from "../../service/locale";
import axios from "axios";
import { getMessageFromError } from "../../service/errors";
import auth from "@/service/auth";
import Sentry from "../../plugins/sentry"

export default {
  name: "RecentExports",
  props: {
    camera: {
      type: Object
    },
    currentRecording: Object,
    showDialog: Boolean,
    accountTimeOffset: Number
  },
  setup(props, context) {
    const data = reactive({
      headers: computed(() => [
        { text: t("Status"), value: "status" },
        { text: t("Type"), value: "type" },
        { text: t("Time of Export"), value: "time" },
        { text:t("Size"), value: "size" },
        { text: "", value: "btn" }
      ]),
      jobs: [],
      downloadingVideo: false,
      checkingJob: false,
      cameraId: computed(() => (props.camera ? props.camera.cameraId : null)),
      cameraName: computed(() => (props.camera ? props.camera.name : "camera")),
      recordingId: computed(() =>
        props.currentRecording ? props.currentRecording.recordingId : null
      ),
      checkJobInterval: null,
      timeoutAlert: null
    });

    const { closeOverlay, checkJobs } = videoExportOverlay(data, context, props);

    checkJobs();

    onMounted(() => {
      clearInterval(data.checkJobInterval);
      data.checkJobInterval = null;
      data.checkJobInterval = setInterval(checkJobs, 2000);
    
    });

    onBeforeUnmount(() => {
      clearInterval(data.checkJobInterval);
      data.checkJobInterval = null;
    });

    return { ...toRefs(data), closeOverlay, checkJobs };
  }
};

function videoExportOverlay(data, context, props) {
  async function checkJobs() {
    if (!data.checkingJob) {
      data.checkingJob = true;
      try {
        let jobs = await restapi.getCameraJobs(data.cameraId);
        jobs = jobs.filter(job => job.type.indexOf("camera.video.") !== -1);
        const processJob = async job => {
          let temp = {};
          if (job.fakeJob) {
            temp = job;
          } else {
            console.log("now processing", job);
            if (job.status === "Created") {
              if (job.statusDetails.videoExportStatus === "Initializing") {
                temp.status = "Queued";
              } else {
                temp.status = "Created";
              }
            } else if (job.status === "Ended") {
              if (job.statusDetails.videoExportStatus === "Success" || job.statusDetails.summaryStatus === "Success") {
                temp.status = 'Done'
                temp.url = `${job.statusDetails.httpsUrl}?access_token=${auth.getToken()}`
                try{
                temp.size = await axios.head(temp.url).then(response => {
                  console.log(response, temp.size)
                  return formatBytes(response.headers['content-length'])
                })
                }
                catch(error) {
                  console.error(error)
                    store.dispatch("toastMessage", { 
                    showing: true,
                    text: getMessageFromError(
                      error,
                      API_CODES.HEAD_VIDEO_EXPORT
                    ),
                    timeout: -1,
                    color: "error",
                    support: true
                  });
                }
              } else {
                temp.status = "Failed";
                temp.size = "-";
                temp.message = job.statusDetails.errorDescription;
              }
            } else if (job.status === "Running") {
              temp.status = "In progress";
            }

            temp.time = new Date(new Date(job.creationTime).getTime() - (props.accountTimeOffset - new Date().getTimezoneOffset()) * 60000)
              .toString()
              .substr(0, 24);
            temp.type =
              job.type === "camera.video.export"
                ? "Video Export"
                : job.type === "camera.video.summary"
                ? "24h Summary"
                : "";
            temp.id = job.jobId;
          }
          return temp;
        };

        jobs = [...store.getters.exports, ...jobs];
        jobs = await Promise.all(jobs.map(job => processJob(job)));
        jobs.sort((a, b) => {
          return new Date(b.time) - new Date(a.time);
        });
        data.jobs = jobs;
        data.checkingJob = false;
      } catch (error) {
        Sentry.captureException(error)
        data.checkingJob = false;
        if (!data.timeoutAlert) {
          data.timeoutAlert = setTimeout(() => {
            data.timeoutAlert = null;
          }, 30000);
          store.dispatch("toastMessage", {
            showing: true,
            text: t(`There was an error getting jobs.`),
            timeout: -1,
            color: "error",
            support: true
          });
        }
      }
    }
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function closeOverlay() {
    context.emit("close");
    clearInterval(data.checkJobInterval);
    data.checkJobInterval = null;
  }

  return { closeOverlay, checkJobs };
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

.overlay-z {
  z-index: 1000 !important;
}

.table {
  // border-top: 1px solid black;
  padding: 0 25px;
  height: 250px;
  overflow: auto;
}

.table-head {
  border-bottom-color: var(--v-primary-lighten1) !important;
  border-bottom-width: 2px !important;
}

.table-cell {
  padding: 10px;
  padding-left: 17px;
  font-size: 0.9em;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.no-exports {
    padding-top: 100px;
    color: #555555;
    font-size: 14px;
  }

  &.status {
    width: 90px;
  }

  &.size {
    width: 80px;
  }

  &.btn {
    width: 70px;
    cursor: pointer;
  }
}

.text-decoration-none {
  text-decoration: none;
}
</style>
